import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const getEmailSubscriptions = async () => {
  return await axiosInstance.get("email-subscriptions/getlist", { headers });
};

export const deleteEmailSubscription = async (id) => {
  return await axiosInstance.delete(`email-subscriptions/delete/${id}`, {
    headers,
  });
};
